import { Dayjs } from 'dayjs';

export type ISODate = string;

export type DateRangeObject = {
  startDate: ISODate;
  endDate: ISODate;
};

export type DateRange = [Dayjs | null, Dayjs | null];

export enum Meridiem {
  AM = 'AM',
  PM = 'PM',
}

export enum FiatPayoutFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export enum Weekday {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum DayOfMonth {
  FirstOfMonth = 0,
  LastOfMonth = 31,
  First = 1,
  Second,
  Third,
  Fourth,
  Fifth,
  Sixth,
  Seventh,
  Eighth,
  Ninth,
  Tenth,
  Eleventh,
  Twelfth,
  Thirteenth,
  Fourteenth,
  Fifteenth,
  Sixteenth,
  Seventeenth,
  Eighteenth,
  Nineteenth,
  Twentieth,
  TwentyFirst,
  TwentySecond,
  TwentyThird,
  TwentyFourth,
  TwentyFifth,
  TwentySixth,
  TwentySeventh,
  TwentyEighth,
  TwentyNinth,
  Thirtieth,
}

export enum CryptoPayoutFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Every12Hours = 'every12hours',
}
